import NoneAnchor from 'components/NoneAnchor'
import { useDispatch } from 'react-redux'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import { useDashboardTableActions } from 'features/dashboard/utils/hooks/useDashboardTableActions'

const DashboardTablePagination = () => {
  const dispatch = useDispatch()
  const { isLoading, page, totalElements } = useDashboardTableSelector()
  const { setPage } = useDashboardTableActions()
  const size = 200
  const first = 0
  const last = Math.max(Math.ceil(totalElements / size) - 1, 0)
  const prev = Math.max(first, page - 1)
  const next = Math.min(last, page + 1)
  const start = page * size + 1
  const end = Math.min((page + 1) * size, totalElements)
  const handlePageChange = v => {
    dispatch(setPage(v))
  }

  return (
    <div className="paging_wrap">
      <div className="inner_paging">
        {totalElements > 0 && (
          <p className="desc_paging">
            {totalElements.toLocaleString()}개 중 {start.toLocaleString()}-
            {end.toLocaleString()}
          </p>
        )}
        {page === first || isLoading ? (
          <>
            <span className="num_paging">
              <span className="ico_comm ico_prevs">맨처음</span>
            </span>
            <span className="num_paging">
              <span className="ico_comm ico_prev">이전</span>
            </span>
          </>
        ) : (
          <>
            <NoneAnchor
              className="num_paging"
              onClick={() => handlePageChange(first)}>
              <span className="ico_comm ico_prevs">맨처음</span>
            </NoneAnchor>
            <NoneAnchor
              className="num_paging"
              onClick={() => handlePageChange(prev)}>
              <span className="ico_comm ico_prev">이전</span>
            </NoneAnchor>
          </>
        )}
        {page === last || isLoading ? (
          <>
            <span className="num_paging">
              <span className="ico_comm ico_next">다음</span>
            </span>
            <span className="num_paging">
              <span className="ico_comm ico_nexts">맨끝</span>
            </span>
          </>
        ) : (
          <>
            <NoneAnchor
              className="num_paging"
              onClick={() => handlePageChange(next)}>
              <span className="ico_comm ico_next">다음</span>
            </NoneAnchor>
            <NoneAnchor
              className="num_paging"
              onClick={() => handlePageChange(last)}>
              <span className="ico_comm ico_nexts">맨끝</span>
            </NoneAnchor>
          </>
        )}
      </div>
    </div>
  )
}
export default DashboardTablePagination
